import { Modal } from "react-bootstrap";
import { useState } from "react";
import { popCancelBttn } from "../../../assets";
import { TransformWrapper, TransformComponent, useControls } from "react-zoom-pan-pinch";
import ZooButton from "../../GenAIAnswering2.0/ZooButton";
import '../../GenAIAnswering2.0/GenAIAuthoringSidebar.css';

export default function ExpandContentModalNoteBook(props) {
    const {
        content,
        showModal,
        handleSaveContent,
        placeholder
    } = props
    const [showPop, setShow] = useState(showModal)
    const [txtValue, setTxtValue] = useState(content)
    const handleTextarea = (e) => {
        setTxtValue(e.target.value)
    }
    const Controls = () => {
        const { zoomIn, zoomOut, resetTransform } = useControls();
        return (
            <div className="tools">
                <div className ="tools-container">
                 <ZooButton
                  text="Zoom_In"
                  customColor="#0074b0"
                  sReset = {false}
                  action={() => zoomIn()}
                />
                <ZooButton
                  text="Zoom_Out"
                  customColor="#0074b0"
                  sReset = {false}
                  action={() => zoomOut()}
                />
                <ZooButton
                  text="Reset"
                  customColor="#0074b0"
                  isReset = {true}
                  action={() => resetTransform()}
                />
                </div>
            </div>
          );
     }
    return (
        <Modal
            size="lg"
            show={showPop}
            keyboard={false}
            dialogClassName="popTimeOut expandContentPopUp"
            className="z-index-alertMessage notebookGenAIPopUp"
            backdropClassName="z-index-alertMessage-backdrop"
        >
            {(txtValue.startsWith('blob:http://') || txtValue.startsWith('blob:https://') )? <>
                <div style={{ padding: "25px" }}>
                <div className="expandContentCancel">
                    <img src={popCancelBttn} alt="" onClick={(e) => { setShow(false); handleSaveContent(txtValue) }} />
                </div>
            <div className="gen-ai-image-container-1">
                <div className="gen-ai-image-container-2">
                    <TransformWrapper
                        defaultPositionX={1}
                        defaultPositionY={1}
                        defaultScale={1}
                    ><TransformComponent>
                            <img className="gen-ai-authoring-img" src={`${txtValue}`} style={{ width: '753px', height: '520px' }} alt="" />
                        </TransformComponent>
                        <><Controls /></>
                    </TransformWrapper>
                </div></div></div>
            </> : <div className="notebook-expand-conc">
                <div className="expandContentCancel">
                    <span onClick={(e) => { setShow(false); handleSaveContent(txtValue) }} >
                   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                   </span>
                </div>
                <textarea value={txtValue} placeholder={placeholder ? placeholder : ""} className="contentTextarea noteBook-feature" style={{border:'none'}} onChange={(e) => handleTextarea(e)} />
            </div>}
        </Modal>
    )
}